import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { getOrderChangeValidation, getOrderDetailsByOrderCode2, updateOrderLocation, getLocationsOfCounter } from "src/services/order-api";
import { Autocomplete, Input } from "src/components";
import { Button } from "src/components";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useDispatch } from "react-redux";
import { ordActions } from "src/context/order-slice";
import FormSuccess from "src/features/fields/container/FormSuccess";

const ChangeCounterLocation = ({ onCloseModal, onSuccess }: { onCloseModal: () => void; onSuccess: () => void }) => {
    const [reason, setReason] = useState<string>("");
    const { toast } = useToast();
  const { orderDetailsFiltered,selectedCounterData } = useSelector((state: RootState) => state.ord);
    const [selectedLocation, setSelectedLocation] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [notAllowed, setNotAllowed] = useState<boolean>(false);
    const { withEventCheck } = useEventStatus();
    const dispatch = useDispatch();

    const orderDetails = orderDetailsFiltered?.[0];

    const handleSaveChanges = async () => {
        if (!selectedLocation) {
            toast({ description: "Please select counter location", variant: "destructive" });
            return;
        }
        if (!reason) {
            toast({ description: "Please enter reason", variant: "destructive" });
            return;
        }
        setIsLoading(true);

        const payloadToValidate = {
            "action": "ORDER_LOCATION_CHANGE",
            "order_number": orderDetails?.order_code,
            "counter_code": selectedLocation?.counter_code,
            "location_code": selectedLocation?.location_code
        }

        const response = await getOrderChangeValidation(payloadToValidate)
        if (response?.data?.success !== "success") {
            setIsLoading(false);
            toast({ description: response?.data?.message, variant: "destructive" });
            return;
        }

        const payload = {
            data: {
                order_id: orderDetails?.order_id_int,
                order_code: orderDetails?.order_code,
                old_location_code: orderDetails?.novu_metadata?.counter_location_code,
                counter_code: selectedLocation?.counter_code,
                new_counter_company_location_id: selectedLocation?.counter_company_location_id,
                new_counter_ff_div_lnk_id: selectedLocation?.counter_ff_div_lnk_id, //M10-13430
                reason: reason,
                //for novu_metadata
                new_location_code: selectedLocation?.location_code,
                new_location_name: selectedLocation?.location_name,
                new_clinic_name: selectedLocation?.clinic_name,
                new_city_name: selectedLocation?.city_name,
                new_counter_address: selectedLocation?.address,
                //M10-12383
                e_way_required: orderDetails?.novu_metadata?.e_way_required,
                e_inv_required: orderDetails?.novu_metadata?.e_inv_required
                //M10-12383
            },
            primary_key: orderDetails?.order_id_int,
            event_type: "ORDER_LOCATION_SHIFT",
        };
        try {
            const response = await updateOrderLocation(payload,orderDetails?.company_code);
            const response2 = await withEventCheck(
                () => {
                    return getOrderDetailsByOrderCode2(orderDetails?.order_code, orderDetails?.company_code);
                },
                response?.data?.data?.eventStreamCreated?.streamId,
                orderDetails?.company_code  //M10-12758
            );
            dispatch(ordActions.setOrderDetailsFiltered([response2?.data?.data]));
            if (response?.status !== 200) throw new Error(response?.data?.message);
            toast({ description: "Counter Location updated successfully", variant: "default" });
            onCloseModal();
            onSuccess();
        } catch (error: any) {
            toast({ description: error?.response?.data?.message, variant: "destructive" });
        } finally {
            setIsLoading(false);
        }
    };

    const queryCounterLocationDetailsPromise = async (searchQuery: any, currentPage: number = 1): Promise<any> => {
        // const orderDetails = orderDetailsFiltered?.[0];
        const params: {
            division_code: number | string;
            excluded_location_id: number | string;
            search: any;
            page: number;
            new_counter_ff_div_lnk_id:number|string
        } = {
            page: searchQuery ? 1 : currentPage,
            new_counter_ff_div_lnk_id:orderDetails?.counter_ff_div_lnk_id,
            search: searchQuery,
            division_code: orderDetails?.company_divisioncode,
            excluded_location_id: selectedCounterData?.locations?.[0]?.id,
        };

        const response = await getLocationsOfCounter(params.division_code,params.new_counter_ff_div_lnk_id, params.excluded_location_id, params.search, params.page);

    return Promise.resolve(response?.data?.data);
  };

    return (
        <div className="flex flex-col gap-y-2 mb-4 w-[340px] max-h-[318px] mx-auto px-6 bg-white p-4 rounded-xl">
            <div className="flex justify-between items-center">
                <p className="text-normal py-1 font-semibold text-[#49484C]">Change Counter Location</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
                </Button>
            </div>
            <div className="">
                <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">Counter Location</p>

                <Autocomplete
                    placeholder="Select Counter Location"
          suggestionList={[]}
                    displayKey="location_name"
          additionalDisplayKey="counter_code"
          additionalDisplayKeySearch={true}
                    uniqueKey="counter_location_id"
                    onSelectionChange={(e: any) => {
                        setSelectedLocation(e);
                    }}
          asyncListFunction={(query: string, currentPage: number) => {
            return queryCounterLocationDetailsPromise(query, currentPage);
          }}
          isAsyncQuery={true}
                />
            </div>
            <div>
                <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">Reason</p>
                <Input
                    type="text"
                    placeholder="Enter Reason"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className="w-full border py-4 border-[#D0D0D0] rounded-md p-2 h-8"
                />
            </div>

            <Button loaderSize="small" isLoading={isLoading} className="text-white bg-[#8051FF] mt-2" onClick={handleSaveChanges}>
                Save Changes
            </Button>
            <FormSuccess
                showForm={notAllowed}
                onContinue={() => setNotAllowed(false)}
                onCloseModal={() => {}}
                variant="error"
                popupMessage={{
                    description: "Order division is not in selected location",
                    title: "Access Denied!",
                }}
            />
        </div>
    );
};

export default ChangeCounterLocation;
